import InfoIcon from '@mui/icons-material/Info';
import { styled, Tooltip } from '@mui/material';

function Info(props: { title: string }) {
    return (
        <Container>
            <Tooltip placement="right" title={props.title}>
                <InfoIcon />
            </Tooltip>
        </Container>
    );
}

const Container = styled('div')(({ theme }) => ({
    marginLeft: theme.spacing(1),
    display: 'flex',
    alignItems: 'center',
}));

export { Info };
